/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ExpertWorkspaceSubscriptionProduct의 타입
 */
export type ExpertWorkspaceSubscriptionProductType = 'PersonalMonthly' | 'PersonalAnnual' | 'TeamMonthly' | 'TeamAnnual';

export const ExpertWorkspaceSubscriptionProductType = {
    PersonalMonthly: 'PersonalMonthly' as ExpertWorkspaceSubscriptionProductType,
    PersonalAnnual: 'PersonalAnnual' as ExpertWorkspaceSubscriptionProductType,
    TeamMonthly: 'TeamMonthly' as ExpertWorkspaceSubscriptionProductType,
    TeamAnnual: 'TeamAnnual' as ExpertWorkspaceSubscriptionProductType
};

